import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Amarjeet Maurya',
    title: "Full Stack Web Developer",
    desciption:"I was born in Thane and went to school R.G.S(Ulhasnagar).I'm highly passionate to develop web-based products and keen on finding solutions for the same. I educate, refine and drive myself to a better person. I am constantly learning. I stay calm when faced with Adversity.",
    image: 'https://www.linkpicture.com/q/pp-0-removebg-preview.jpg',
    resumePdf: resume
}
